module.exports = __webpack_public_path__ + "img/40_38_033_390.730bf17b.jpg";